import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShowInvoiceService {

  public shouldReload = false;
  private _closeParams: Record<string, string | number | boolean> = null;

  public set closeParams(value: Record<string, string | number | boolean>) {
    this._closeParams = { ...this._closeParams, ...value };
  }

  public get closeParams(): any {
    return this._closeParams;
  }

  resetReload(): void {
    this.shouldReload = false;
    this._closeParams = null;
  }
}
